<h3>
  <button (click)="modStock()" id="stock_mod_button">Modify Stock</button>
  <button (click)="exportStockCSV()" id="stock_mod_button">Export as .csv</button>
</h3>
<ng-container *ngIf="modifyPanelVisible" style="display:inline;">
  <mod-stock
    [inSerialList]="serialIds"
    (mod_made)="onModMade($event)"></mod-stock>
</ng-container>
<div *ngIf="hubinfo; else nostock" style="display:block">
  <ul class="stock_actions">
    <li>
      <span class="hubid">Serial Id</span>
      <span class="seai_label">Shipment</span>
      <span class="seai_label">Carton</span>
      <span class="label_stock_status">Stock Status</span>
      <span class="label_stock_location">Stock Location</span>
      <span class="installation_customer_type">Installer</span>
      <span class="installation_state_text">Installation State</span>
      <span class="installation_customer_type">Customer Type</span>
      <span class="installation_customer_type">Office Status</span>
      <!--span class="seai_label">SEAI Group</span-->
      <!--span class="date_dispatched_text">Dispatched</span-->
      <span class="date_installed_text">Installed</span>
    </li>
    <li>
      <span class="hubid">
        <select class="form-control" id="hub_id" required [(ngModel)]="ascDscFilter" name="hubid" (change)="filterAscDsc('ascDsc', ascDscFilter)">
          <option value="0">ASC</option>
          <option value="1">DSC</option>
        </select>
      </span>
      <span class="seai_label">
        <select class="form-control" id="shipment" required [(ngModel)]="shipmentFilter" name="shipment" (change)="filterShipment('shipment_number', shipmentFilter)">
          <option value="0">ALL</option>
          <option *ngFor="let shipment of shipment_list" [value]="shipment.shipment_id">{{shipment.shipment_id}}</option>
        </select>
      </span>
      <span class="seai_label">
        <select class="form-control" id="carton" required [(ngModel)]="cartonFilter" name="carton" (change)="filterCarton('carton_number', cartonFilter)">
          <option value="0">ALL</option>
          <option *ngFor="let carton of cartons" [value]="carton">{{carton}}</option>
          <!--option *ngFor="let shipment of shipment_list" [value]="shipment.shipment_id">{{shipment.shipment_id}}</option-->
        </select>
      </span>
      <span class="label_stock_status">
        <select class="form-control" id="stock_status" required [(ngModel)]="statusFilter" name="status" (change)="filterStatus('stock_status_id', statusFilter)">
          <option value="0">ALL</option>
          <option *ngFor="let status of stock_statuses" [value]="status.stock_status_id">{{status.stock_status_text}}</option>
        </select>
      </span>
      <span class="label_stock_location">
        <select class="form-control" id="stock_location" required [(ngModel)]="locationFilter" name="location" (change)="filterLocation('stock_location_id', locationFilter)">
          <option value="0">ALL</option>
          <option *ngFor="let location of stock_locations" [value]="location.stock_location_id">{{location.name}}</option>
        </select>
      </span>
      <span class="installation_customer_type">
        <select class="form-control" id="installer_name" required [(ngModel)]="installerFilter" name="installer" (change)="filterInstaller('installer_id', installerFilter)">
          <option value="0">ALL</option>
          <option *ngFor="let installer of installer_list" [value]="installer.installer_id">{{installer.installer_name}}</option>
      </select>
      </span>
      <span class="installation_state_text">
        <select class="form-control" id="installation_state" required [(ngModel)]="stateFilter" name="state" (change)="filterState('installation_state_id', stateFilter)">
          <option value="0">ALL</option>
          <option *ngFor="let state of installation_states" [value]="state.installation_state_id">{{state.installation_state_text}}</option>
        </select>
      </span>
      <span class="installation_customer_type">
        <select class="form-control" id="customer_type" required [(ngModel)]="customerFilter" name="customer" (change)="filterCustomer('customer_type_id', customerFilter)">
          <option value="0">ALL</option>
          <option *ngFor="let type of customer_types" [value]="type.customer_type_id">{{type.description}}</option>
        </select>
      </span>
            <span class="installation_customer_type">
        <select class="form-control" id="stock_office_status" required [(ngModel)]="stockOfficeStatusFilter" name="stockoffice" (change)="filterStockOfficeStatus('stock_office_status_id', stockOfficeStatusFilter)">
          <option value="0">ALL</option>
          <option *ngFor="let status of stock_office_status" [value]="status.stock_office_status_id">{{status.stock_office_status_details}}</option>
        </select>
      </span>
      <!--span class="seai_label">
        <select class="form-control" id="seai_status" required [(ngModel)]="seaiFilter" name="seai" (change)="filterSEAI('seai_trial_group', seaiFilter)">
          <option value="999">ALL</option>
          <option *ngFor="let group of seai_groups" [value]="group">{{group}}</option>
        </select>
      </span-->
      <!--span class="date_dispatched_text"></span-->
      <span class="date_installed_text"></span>
    </li>
    <li *ngFor="let info of hubinfo">
      <span style="display:block">
        <span class="hubid">{{getSerial(info.hubid)}}</span>
        <span class="seai_label">{{info.shipment_number}}</span>
        <span class="seai_label">{{info.carton_number}}</span>
        <span class="label_stock_status">{{info.stock_status_text}}</span>
        <span class="label_stock_location">{{info.name}}</span>
        <span class="installation_customer_type">{{info.installer_name}}</span>
        <span class="installation_state_text">{{info.installation_state_text}}</span>
        <span class="installation_customer_type">{{info.description}}</span>
        <span class="installation_customer_type">{{info.stock_office_status_details}}</span>
        <!--span class="seai_label">{{info.seai_trial_group}}</span-->
        <!--span class="date_dispatched_text">{{info.dispatched }}</span-->
        <span class="date_installed_text">{{info.installed }}</span>
      </span>
    </li>
  </ul>
</div>
<ng-template #nostock>
  <br><br>No Stock for that criteria<br>
</ng-template>
